import React, { useCallback, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TaskList from './components/task-list';
import TaskItem from './components/task-item';
import http from 'src/services/httpService';
import errorHandler from '../../../utils/error-handler';

function Kanban({
  columnsKanban,
  columnsCard,
  filtrando,
  model,
  parameters,
  listagemUnica = false,
  list: listProp,
  handleChangeFiltrandoBloqueado,
  handleDescricaoClick,
}) {
  const [list, setList] = useState(listProp != null ? listProp : []);
  const [taskFantasma, setTaskFantasma] = useState(null);

  useEffect(() => {
    if (listProp != null) setList(listProp);
  }, [listProp]);

  //Não é utilizado para listagem única
  const itensLista = useCallback(
    (statusId) => {
      try {
        let lista;
        if (list.length && list.filter((ls) => ls.itens).length)
          lista = list.find(
            (ls) => ls.itens.filter((item) => item.status.id == statusId).length
          );
        else lista = list.find((item) => item.id == statusId);

        return lista ? lista.itens : [];
      } catch (err) {
        return [];
      }
    },
    [list]
  );

  const getRealCount = useCallback(
    (statusId) => {
      try {
        let lista;
        if (list.length && list.filter((ls) => ls.itens).length)
          lista = list.find(
            (ls) => ls.itens.filter((item) => item.status.id == statusId).length
          );
        else lista = list.find((item) => item.id == statusId);

        return lista ? lista.qntRealItens : 0;
      } catch (err) {
        return 0;
      }
    },
    [list]
  );

  //Não é utilizado para listagem única
  const removeAndAddListas = useCallback(
    (sourceId, destinationId, draggableId, farol) => {
      setList((currentList) => {
        const newLists = currentList.map((item) => ({
          ...item,
          itens: item.itens ? [...item.itens] : item.itens,
        }));
        const sourceList = newLists.find((item) => item.id === sourceId);
        const destinationList = newLists.find(
          (item) => item.id === destinationId
        );
        const itensSource = sourceList && sourceList.itens;
        const itensDestination = destinationList && destinationList.itens;

        if (!itensSource) return currentList;

        const index = itensSource.findIndex((acao) => acao.id == draggableId);
        if (index == -1) return currentList;

        const acao = {
          ...itensSource[index],
          status: { id: destinationId },
          farolAcao: farol,
        };

        if (itensSource[index].status?.id == destinationId)
          itensSource[index] = acao;
        else {
          itensSource.splice(index, 1);
          itensDestination && itensDestination.unshift(acao);
        }

        return newLists;
      });
    },
    []
  );

  //Utilizado para listagem única
  const removeAndAddListaUnica = useCallback(
    (draggableId, destinationId, farol = null) => {
      setList((currentList) => {
        const listaCopia = [...currentList];
        const acaoIndex = listaCopia.findIndex(
          (acao) => acao.id == draggableId
        );

        if (acaoIndex == -1) return currentList;

        const acao = {
          ...listaCopia[acaoIndex],
          status: { id: destinationId },
          farolAcao: farol,
        };

        if (listaCopia[acaoIndex].status?.id == destinationId)
          listaCopia[acaoIndex] = acao;
        else {
          listaCopia.splice(acaoIndex, 1);
          listaCopia.unshift(acao);
        }

        return listaCopia;
      });
    },
    []
  );

  //Sempre utilizado
  const callRemoveAndAdd = useCallback(
    (sourceId, draggableId, destinationId, farol = null) => {
      if (listagemUnica)
        removeAndAddListaUnica(draggableId, destinationId, farol);
      else {
        removeAndAddListas(sourceId, destinationId, draggableId, farol);
        handleChangeFiltrandoBloqueado && handleChangeFiltrandoBloqueado();
      }
    },
    [
      handleChangeFiltrandoBloqueado,
      listagemUnica,
      removeAndAddListaUnica,
      removeAndAddListas,
    ]
  );

  //Sempre utilizado
  const handleDragStart = useCallback(
    (event) => {
      if (listagemUnica)
        setTaskFantasma(list.find((item) => item.id == event.draggableId));
      else {
        const source = event.source;
        setTaskFantasma(
          itensLista(source && source.droppableId).find(
            (item) => item.id == event.draggableId
          )
        );
      }
    },
    [itensLista, list, listagemUnica]
  );

  //Sempre utilizado
  const handleDragEnd = useCallback(
    (event) => {
      setTaskFantasma(null);

      const { source, destination } = event;
      if (!destination) return;

      const destinationId = parseInt(destination.droppableId, 10);
      const sourceId = parseInt(source.droppableId, 10);

      //Joga na lista antes de salvar, para não haver delay
      callRemoveAndAdd(sourceId, event.draggableId, destinationId);

      //posteriormente caso tenha alguma alteração, as tasks são reorganizadas
      http
        .post(`/Acao/AlterarApenasStatus`, {
          acaoId: event.draggableId,
          novoStatusId: destinationId,
        })
        .then((response) => {
          callRemoveAndAdd(
            destinationId,
            event.draggableId,
            response.data.status && response.data.status.id,
            response.data.farol
          );
        })
        .catch((error) => {
          callRemoveAndAdd(destinationId, event.draggableId, sourceId);
          errorHandler(error);
        });
    },
    [callRemoveAndAdd]
  );

  //Não é utilizado para listagem única
  const adicionarLista = useCallback((lista) => {
    setList((currentList) => {
      const listaCopia = [...currentList];
      const indexLista = listaCopia.findIndex((item) => item.id == lista.id);

      if (indexLista == -1) listaCopia.push(lista);
      else listaCopia[indexLista] = lista;

      return listaCopia.filter(
        (item, index, array) =>
          array.findIndex((currentItem) => currentItem.id === item.id) === index
      );
    });
  }, []);

  const columnsCardFinal = Object.assign([], columnsCard);

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          flexGrow: 1,
          overflowX: 'auto',
          overflowY: 'hidden',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          height: '75vh',
        }}
      >
        <DragDropContext
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
        >
          {columnsKanban &&
            columnsKanban.map((column) => (
              <Droppable droppableId={column.id + ''} key={column.id}>
                {(provided, snapshot) => (
                  <TaskList
                    listagemUnica={listagemUnica}
                    adicionarLista={adicionarLista}
                    statusId={column && column.id}
                    filtrando={filtrando}
                    model={model}
                    parameters={parameters}
                    quantidadeColunas={columnsKanban && columnsKanban.length}
                    provided={provided}
                    snapshot={snapshot}
                    title={column.headerText}
                    total={
                      listagemUnica
                        ? list &&
                          list.filter((a) => a.status.id == column.id).length
                        : getRealCount(column.id)
                    }
                  >
                    {taskFantasma && (
                      <div
                        style={{
                          display: snapshot.isDraggingOver ? 'block' : 'none',
                        }}
                      >
                        <TaskItem
                          ehFantasma={true}
                          columnsCard={columnsCardFinal}
                          task={taskFantasma}
                        />
                      </div>
                    )}
                    {(listagemUnica
                      ? list && list.filter((a) => a.status.id === column.id)
                      : itensLista(column.id)
                    ).map((task, index) => (
                      <Draggable
                        draggableId={task.id + ''}
                        index={index}
                        key={task.id}
                      >
                        {(provided, snapshot) => (
                          <TaskItem
                            handleDescricaoClick={handleDescricaoClick}
                            columnsCard={columnsCardFinal}
                            provided={provided}
                            snapshot={snapshot}
                            task={task}
                            setTaskFantasma={setTaskFantasma}
                            taskFantasma={taskFantasma}
                          />
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </TaskList>
                )}
              </Droppable>
            ))}
        </DragDropContext>
      </div>
    </div>
  );
}

export default Kanban;
